import React from 'react'
import { render } from 'react-dom'
import Root from './Root'
import './assets/styles/index.scss'

render(<Root />, document.getElementById('app'))
